import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from '../../shared/services/appsettings.service';
import { SettingsService } from '../../shared/services/settings.service';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
    selector: '[app-footer]',
    template: require('./footer.component.html'),
    styles: [require('./footer.component.scss')]
})
export class FooterComponent implements OnInit {
    public version = '1.0.0';
    constructor(
        public settings: AppSettingsService,
        private settingsService: SettingsService,
        private notificationService: NotificationService) { }

    ngOnInit() {
        this.settingsService.getVersion().then(response => {
            this.version = response;                        
        }).catch(e => this.notificationService.handleGlobalErrors(e));
    }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/layout/footer/footer.component.ts